module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-invitation-d7807158ed6eb811dc472d336d6bf7b2.png";